/* eslint-disable no-unused-vars */

import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../../../Axios/AxiosBaseQuery';
const URL = 'intern-service/profile';
// Create the API using createApi
export const GetPersonalInformationApi = createApi({
  reducerPath: 'GetPersonalInformationApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['profile'],
  staleTime: 1,
  endpoints: (builder) => ({
    getData: builder.query({
      query: () => ({ url: URL, method: 'GET' }),
      providesTags: ['profile'],
    }),
    saveCorrectName: builder.mutation({
      query: (data) => ({ url: 'intern-service/profile/name', method: 'PATCH', body: data }),
      invalidatesTags: ['profile'],
    }),
    savePhoneNumber: builder.mutation({
      query: (data) => ({
        url: 'intern-service/profile/phone-number',
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['profile'],
    }),
    saveGender: builder.mutation({
      query: (data) => ({ url: 'intern-service/profile/gender', method: 'PATCH', body: data }),
      invalidatesTags: ['profile'],
    }),
    saveCitizenship: builder.mutation({
      query: (data) => ({ url: 'intern-service/profile/citizenship', method: 'POST', body: data }),
      invalidatesTags: ['profile'],
    }),
    saveEthnicity: builder.mutation({
      query: (data) => ({
        url: 'intern-service/profile/racial-ethnic-group',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['profile'],
    }),
    saveDisability: builder.mutation({
      query: (data) => ({ url: 'intern-service/profile/disability', method: 'POST', body: data }),
      invalidatesTags: ['profile'],
    }),
    saveFirstGenUni: builder.mutation({
      query: (data) => ({
        url: 'intern-service/profile/first-gen-student',
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['profile'],
    }),
    saveApplicationInternationalStudent: builder.mutation({
      query: (data) => ({
        url: 'intern-service/profile/international-student',
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['profile'],
    }),
    saveInternshipGoals: builder.mutation({
      query: (data) => ({
        url: 'intern-service/profile/skill/internship-goal',
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['profile'],
    }),
    saveJobTitle: builder.mutation({
      query: (data) => ({
        url: 'intern-service/profile/skill/job-title',
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['profile'],
    }),
    saveApplicationEnglishProficiency: builder.mutation({
      query: (data) => ({
        url: 'intern-service/profile/english-proficiency',
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['profile'],
    }),
    saveApplicationLowEnglishProficiency1: builder.mutation({
      query: (data) => ({
        url: 'intern-service/profile/low-english-proficiency',
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['profile'],
    }),
    saveApplicationLowEnglishProficiency2: builder.mutation({
      query: (data) => ({
        url: 'intern-service/profile/low-english-proficiency2',
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['profile'],
    }),
    saveApplicationLowEnglishProficiency3: builder.mutation({
      query: (data) => ({
        url: 'intern-service/profile/low-english-proficiency3',
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['profile'],
    }),
    saveApplicationLowEnglishProficiency4: builder.mutation({
      query: (data) => ({
        url: 'intern-service/profile/low-english-proficiency4',
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['profile'],
    }),
  }),
});

// Export hooks for usage in components
export const {
  useGetDataQuery,
  useSaveCorrectNameMutation,
  useSavePhoneNumberMutation,
  useSaveGenderMutation,
  useSaveCitizenshipMutation,
  useSaveEthnicityMutation,
  useSaveDisabilityMutation,
  useSaveFirstGenUniMutation,
  useSaveApplicationInternationalStudentMutation,
  useSaveInternshipGoalsMutation,
  useSaveJobTitleMutation,
  useSaveApplicationEnglishProficiencyMutation,
  useSaveApplicationLowEnglishProficiency1Mutation,
  useSaveApplicationLowEnglishProficiency2Mutation,
  useSaveApplicationLowEnglishProficiency3Mutation,
  useSaveApplicationLowEnglishProficiency4Mutation,
} = GetPersonalInformationApi;
// Export the auto-generated hooks and reducer
export default GetPersonalInformationApi.reducer;
